export const apiZoomIn = (map) => {
  if (map) {
    map.map.zoomIn()
  }
}
